// extracted by mini-css-extract-plugin
export default {"wrappButton":"ChangePassword_wrappButton__Up6fh"};